import moment from 'moment';
import { batchRecordExport, batchDownRecordVerify, groupRecordDownload } from '../request';
import { downloadFileFun } from '@/utils/public';
export default {
  props: {
    batchDownVisible: {
      type: Boolean,
      default: false
    },
    policyPurpose: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dateRange: [],
      correctionDataSource: [],
      isLoading: false
    };
  },
  watch: {
    batchDownVisible: {
      handler(val) {
        if (val) {
          this.dateRange = [];
        }
      }
    }
  },
  methods: {
    searchDown() {
      if (this.isLoading) {
        return;
      }
      if (this.dateRange.length >= 2) {
        let diff = moment(this.dateRange[1]).diff(this.dateRange[0], 'months', true);
        if (diff > 3) {
          this.$message.error(this.$t('选择时间范围不能超过3个月，请重新选择'));
          return;
        }
        this.isLoading = true;
        let params = {
          policyId: Number(this.$route.params.id),
          correctEffectiveAt: moment(this.dateRange[0]).format('YYYY-MM-DD') + '~' + moment(this.dateRange[1]).format('YYYY-MM-DD')
        };
        let downRequestMethod = this.policyPurpose === 'groupInsurance' ? groupRecordDownload : batchRecordExport;
        batchDownRecordVerify(params).then(res => {
          if (res === true) {
            this.isLoading = true;
            downRequestMethod(params).then(res => {
              console.log(res, 'res');
              if (res) {
                let name = '批改记录' + moment().format('YYYYMMDD');
                downloadFileFun(res, 'application/vnd.ms-excel', name + '.xlsx');
              }
            }).finally(() => {
              this.isLoading = false;
            });
          } else {
            this.$message.error(res.message);
            this.isLoading = false;
          }
        }).catch(() => {
          this.isLoading = false;
        });
      } else {
        this.$message.error(this.$t('请选择批改生效时间'));
      }
    }
  }
};